import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { FromToDatePicker } from '@/ui/components'
import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isInModal?: boolean
  store: any
}

const SpotSanitySpotSanityDates = ({
  isInModal,
  className,
  store,
  ...props
}: Props) => {
  const { setStartDate, setEndDate, startDate, endDate } = store()
  const D = useStoreI18n.use.dictionary()

  const handleFromDateSelect = (date: Date) => {
    setStartDate(date)
    if (endDate && date && endDate < date) {
      setEndDate(null)
    }
  }

  const handleToDateSelect = (date: Date) => {
    setEndDate(date)
  }

  const handleFromDateClear = () => {
    setStartDate(null)
  }

  const handleToDateClear = () => {
    setEndDate(null)
  }

  return (
    <FromToDatePicker
      fromName="date_from"
      fromId="date_from"
      fromLabel={D['fe.plugin.filters.from']}
      fromPlaceholder={D['fe.events.filters.dateRange']}
      toName="date_to"
      toId="date_to"
      className={cn('min-w-[220px]', className)}
      addDaysAmount={0}
      fromValue={startDate || undefined}
      toValue={endDate || undefined}
      onFromDateSelect={handleFromDateSelect}
      onToDateSelect={handleToDateSelect}
      onFromDateClear={handleFromDateClear}
      onToDateClear={handleToDateClear}
      toLabel={D['fe.plugin.filters.to']}
      toPlaceholder={D['fe.events.filters.dateRange']}
      {...props}
    />
  )
}

export default memo(SpotSanitySpotSanityDates)
